import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_LOCAL_API || "";
const API_ROOT_URL = API_BASE_URL.replace(/\/auth\/v1\/?$/, "");

const axiosInstance = (userToken) => {
  const instance = axios.create({
    baseURL: API_BASE_URL,
    headers: {
      Authorization: `Bearer ${userToken}`,
    },
    maxBodyLength: Infinity,
  });

  instance.interceptors.request.use((config) => {
    if (
      config?.url &&
      config.url.startsWith("/v2/") &&
      API_ROOT_URL &&
      API_ROOT_URL !== API_BASE_URL
    ) {
      config.baseURL = API_ROOT_URL;
    }
    return config;
  });

  return instance;
};

export default axiosInstance;